import { Provider } from '@angular/core';
import { FileAttachmentSource, provideAttachmentSource } from '@panaya/ai-chat/ui';
import { REQUIREMENT_ATTACHMENT_SOURCE } from './requirement-attachment-source';

/** The "+" menu item "Upload files". Shown so the flow can be tried; its files are not uploaded or sent yet. */
const UPLOAD_FILES_ATTACHMENT_SOURCE: FileAttachmentSource = {
    kind: 'file',
    resourceType: 'file',
    labelKey: 'seemore.attach.upload_files',
    icon: 'paperclip',
    group: 'files'
};

/** The chat's "+" menu items, in menu order. Seemore's `REQUEST_RESOURCES.allowed` picks which of them show on a turn. */
export const seemoreAttachmentSourceProviders: Provider[] = [
    provideAttachmentSource(REQUIREMENT_ATTACHMENT_SOURCE),
    provideAttachmentSource(UPLOAD_FILES_ATTACHMENT_SOURCE)
];
